import { useContext } from 'react';

import { Theme, useTheme } from '@mui/material';

import { UserTypeContext } from '@/shared/lib/UserTypeContext/UserTypeContext';

export type ModuleType = 'location' | 'advertiser' | 'service' | 'backoffice';

export const MODULE_HUE: Record<ModuleType, 'purple' | 'magenta' | 'blue' | 'orange'> = {
  location: 'purple',
  advertiser: 'magenta',
  service: 'blue',
  backoffice: 'orange',
};

export const getModuleChipColors = (
  palette: Theme['palette'],
  userType: ModuleType | undefined,
) => {
  const colorMap: Record<ModuleType, { bg: string; text: string }> = {
    location: { bg: palette.purple[100], text: palette.purple[600] },
    advertiser: { bg: palette.magenta[100], text: palette.magenta[500] },
    service: { bg: palette.blue[100], text: palette.blue[600] },
    backoffice: { bg: palette.orange[100], text: palette.orange[600] },
  };
  return colorMap[userType ?? 'location'] ?? colorMap.location;
};

export const getModuleAccentColor = (
  palette: Theme['palette'],
  userType: ModuleType | undefined,
): string => {
  const hue = MODULE_HUE[userType ?? 'location'] ?? MODULE_HUE.location;
  return palette[hue][500];
};

export const useModuleChipColors = () => {
  const userType = useContext(UserTypeContext) as ModuleType;
  const { palette } = useTheme();
  return getModuleChipColors(palette, userType);
};
